import React from 'react'
import { FaArrowLeft } from 'react-icons/fa'
import ProfileNavbar from '../../../../components/Profile-navbar/profile-navbar' 
import bullet from '../../../../images/bullet.svg'
import outline from '../../../../images/outline.svg'
import clock from '../../../../images/clock.svg'
import starbadge from '../../../../images/starbadge.svg'
import frontend from '../../../../images/frontend.svg'
import { Link } from 'react-router-dom'
import { Container, Form,Card, Row, Col, Button } from 'react-bootstrap'

const Details = () => {
  return (
    <div>
      <ProfileNavbar/>
        <Container fluid className='p-md-5 p-2'>
          <div className='align-items-center text-center mt-5'>
            <p className='test-head mb-3'>IQ TESTS</p>
          </div>
          <Link to='/assessments' className='test-details text-decoration-none mt-5 pt-5'><FaArrowLeft className='me-3'/> Frontend Development Test Details</Link>
          <div className='test-details-section'>
            <img src={frontend}/>
            <div className='mt-3 gap-3 test-description'>
                <h4>Frontend Development</h4>
                <h5>Topics: Javascript, React, HTML fundamentals, CSS </h5>
                <p>1000 people taken test so far</p>
            </div>
            <div className='gap-5 mt-4'>
                <div className='d-flex gap-4 take-info'>
                    <img src={outline}/>
                    <p>20 Multiple Choice Questions</p>
                </div>
                <div className='d-flex gap-4 take-info'>
                    <img src={clock}/>
                    <p>1 minute per question</p>
                </div>
                <div className='d-flex gap-4 take-info'>
                    <img src={starbadge}/>
                    <p>Score in the top 40% to earn a badge</p>
                </div>
            </div>
            <div className='test-line'></div>
            <div className='gap-4 points'>
                <h4 className='mb-2'>Points to Note</h4>
                <div className='d-md-flex d-block align-items-center justify-content-between'>
                <div className=''>
                <div className='d-flex bullet-point align-items-center gap-3'>
                    <img src={bullet}/>
                    <p>Tests need to be taken in one go</p>
                </div>
                <div className='d-flex bullet-point align-items-center gap-3'>
                    <img src={bullet}/>
                    <p> Tests can be retaken twice if top score is not met</p>
                </div>
                <div className='d-flex bullet-point align-items-center gap-3'>
                    <img src={bullet}/>
                    <p>Results are private to you unless you give permission to be made public</p>
                </div>
                </div>
                <button className='take-test-btn mt-4 mt-md-0'>Start Test</button>

                </div>
            </div>
          </div>
        </Container>
    </div>
  )
}

export default Details
